import { useCallback, useState } from 'react';

import { emptyMemosState } from '..';

export const useMemos = () => {
  const [memos, setMemos] = useState(emptyMemosState);

  const clearMemos = useCallback(() => {
    setMemos(emptyMemosState);
  }, []);

  return { memos, setMemos, clearMemos };
};
